module.exports = __webpack_public_path__ + "img/C03TechFuror_ua.68db8800.webp";